import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-dialog-non-admin-after-auth',
  templateUrl: './dialog-non-admin-after-auth.component.html',
  styleUrls: ['./dialog-non-admin-after-auth.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DialogNonAdminAfterAuthPopupComponent {}
